import { render, staticRenderFns } from "./ZhStatic.vue?vue&type=template&id=00030c20&scoped=true"
import script from "./ZhStatic.vue?vue&type=script&lang=js"
export * from "./ZhStatic.vue?vue&type=script&lang=js"
import style0 from "./ZhStatic.vue?vue&type=style&index=0&id=00030c20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00030c20",
  null
  
)

export default component.exports